import React, { Context } from 'react';

export type Theme = 'light' | 'dark';

export interface ColorProps {
    bgColor: string;
    color: string;
}

export interface ThemePropType {
    light: ColorProps;
    dark: ColorProps;
}

export interface ContextType {
    themes: ThemePropType;
}

export interface ThemeContextType {
    theme: Theme;
    updateTheme: Function;
}

export const globalConfig: ContextType = {
    themes: {
        dark: {
            color: '',
            bgColor: '',
        },
        light: {
            color: '#ed4767',
            bgColor: '#ffffff',
        },
    },
};

export const defaultTheme: ThemeContextType = { theme: 'light', updateTheme: () => { } };

export const themeContext: Context<ThemeContextType> = React.createContext(defaultTheme);
